import * as z from "../../../../framework";
import * as ui from "../../ui";

var view = () => new ui.Container({
    components: [
        new ui.Container({
            id: "AboutContainer",
            classes: "about-container",
            components: [
                new ui.Container({
                    classes: "sp-logo-color"
                }),
                new ui.Container({
                    classes: "pane-row container",
                    components: [
                        new ui.LabelLabel({
                            bindLabel: "VersionNumber",
                            bindValue: "VNumber",
                            classes: "about-label-large",
                            containerClasses: "about-label-large"
                        })
                    ]
                }),
                new ui.Container({
                    classes: "pane-row container about-version-container",
                    components: aboutInfo()
                }),

                // Bottom row - copyright and 'Learn More' link
                new ui.Label({
                    bindLabel: "MSIData",
                    bindValue: "MSIData",
                    classes: "left"
                }),
                new ui.Link({
                    bindLabel: "MSILabel",
                    href: (z.settings.appSettings.learnMoreAboutURL || "http://www.msidata.com"),
                    classes: "right"
                }),
                new ui.Label({
                    bindLabel: "LearnMoreAbout",
                    bindValue: "LearnMoreAbout",
                    classes: "right"
                })
            ]
        })
    ]
});

function aboutInfo(): ui.Component[] {

    let aboutContainerContents = [
        new ui.LabelLabel({
            bindLabel: "AppVersion",
            bindValue: "AVersion",
            classes: "about-label-small",
            containerClasses: "about-label-small"
        }),

        new ui.CollapsableContainer({
            id: "VersionInfo",
            header: "VersionInfoLabel",
            components: [
                new ui.LabelLabel({
                    bindLabel: "ApiServiceVersion",
                    bindValue: "ApiVersion",
                    classes: "about-label-small",
                    containerClasses: "about-label-small"
                }),
                new ui.LabelLabel({
                    bindLabel: "CompanyDatabaseVersion",
                    bindValue: "CompanyDbVersion",
                    classes: "about-label-small",
                    containerClasses: "about-label-small"
                }),
                new ui.LabelLabel({
                    bindLabel: "CoreDatabaseVersion",
                    bindValue: "CoreDbVersion",
                    classes: "about-label-small",
                    containerClasses: "about-label-small"
                }),
                new ui.LabelLabel({
                    bindLabel: "DefaultCdnVersionLabel",
                    bindValue: "DefaultCdnVersion",
                    classes: "about-label-small",
                    containerClasses: "about-label-small"
                }),
                new ui.LabelLabel({
                    bindLabel: "DefaultStackVersionLabel",
                    bindValue: "DefaultStackVersion",
                    classes: "about-label-small",
                    containerClasses: "about-label-small"
                }),
            ]
        })
    ];

    if (z.settings.brandName == "servicepro") {
        aboutContainerContents.push(
            new ui.Link({
                href: "https://servicepro10.status.io/",
                bindLabel: "StatusPage",
                classes: "about-link status-page",
                containerClasses: "about-link",
                openNewTab: true
            })
        );
    }

    return aboutContainerContents;
}

export default view;
